class HowItWorksInformation {
  text: string;
  img: string;
  extra: string | null;
  link: string | null;
  ref: string;

  constructor(
    text: string,
    img: string,
    extra: string | null = null,
    link: string | null = null,
    ref: string = '#'
  ) {
    this.text = text;
    this.img = img;
    this.extra = extra;
    this.link = link;
    this.ref = ref;
  }
}

const search = new HowItWorksInformation(
  'Проект реализован на открытом исходном коде. Любой обладающий навыками программирования, может провести аудит программного кода и убедиться в прозрачности реализованного решения.',
  'search'
);

const blockchain = new HowItWorksInformation(
  'Данные хранятся таким образом, что в случае замены или удаления данных все остальные записи, расположенные в цепочке блоков, необходимо также изменить, так как каждый следующий блок ссылается на предыдущий.',
  'blockchain',
  'Подробнее про технологию блокчейн можно прочитать на ',
  'Википедии',
  'https://ru.wikipedia.org/wiki/%D0%91%D0%BB%D0%BE%D0%BA%D1%87%D0%B5%D0%B9%D0%BD'
);

export const HOW_IT_WORKS_BLOCKS = [blockchain, search];
